
import {
  getProductPage, addProduct, updateProduct, delProduct, getProductById,
  getProductCategory, updateProductCategoryById, addProductCategory, delProductCategoryById

} from '@/api/product'
import { message } from 'ant-design-vue'

export class ProductController {
  static async page (params: COMMON.API.QueryParams) {
    const { code, data } = await getProductPage(params)
    return {
      code,
      data: data.records,
      sum: data.total
    }
  }

  static async add (data: PRODUCT.Detail) {
    const { code, msg } = await addProduct(data)
    code === 0 ? message.success('新增成功') : message.error(msg)
    return code
  }

  static async update (data: PRODUCT.Detail) {
    const { code, msg } = await updateProduct(data)
    code === 0 ? message.success('修改成功') : message.error(msg)
    return code
  }

  static async delById (id: string) {
    const { code, msg } = await delProduct(id)
    code === 0 ? message.success('删除成功') : message.error(msg)
  }

  static async byId (id: string) {
    const { code, data } = await getProductById(id)
    return data
  }

  static async listCategory () {
    const { data } = await getProductCategory()
    return data
  }

  static async updateCategory (data: PRODUCT.Category) {
    const { code, msg } = await updateProductCategoryById(data)
    code === 0 ? message.success('编辑成功') : message.error(msg)
    return code
  }

  static async addCategory (data: PRODUCT.Category) {
    const { code, msg } = await addProductCategory(data)
    code === 0 ? message.success('新增成功') : message.error(msg)
    return code
  }

  static async delCategoryById (id: string) {
    const { code, msg } = await delProductCategoryById(id)
    code === 0 ? message.success('删除成功') : message.error(msg)
  }
}
